import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import LinkBody from "~/components/LinkBody";
import { signupActions } from "~/services/signup";
import { useMount } from "~/services/utils/hooks";
import LandingTemplate from "~/templates/LandingV2";
import { Translation, useTranslation } from "~/components/Translation";
import usePageTrack from "~/services/analytics/usePageTrack";
import analytics from "~/services/analytics";
var PartnerLandingTemplate = function(param) {
    var image = param.image, name = param.name, preTitle = param.preTitle, preTitleKey = param.preTitleKey, partner = param.partner, partnerClick = param.partnerClick, partnerDescription = param.partnerDescription, partnerDescriptionKey = param.partnerDescriptionKey, partnerNameKey = param.partnerNameKey;
    var partnersDescription = useTranslation("landing.partners.description", {
        name: name
    });
    usePageTrack({
        name: analytics.events.PARTNER,
        category: analytics.events.category.MARKETING,
        partnerName: name
    });
    // Save that user signed up through this page
    useMount(function() {
        partnerClick({
            partner: partner,
            referrerType: "partner"
        });
    });
    return /*#__PURE__*/ _jsx(LandingTemplate, {
        preTitle: preTitleKey ? /*#__PURE__*/ _jsx(Translation, {
            tid: preTitleKey
        }) : preTitle,
        heading: /*#__PURE__*/ _jsx(Translation, {
            tid: "landing.title"
        }),
        recommendedBy: {
            image: image,
            text: partnerDescriptionKey ? /*#__PURE__*/ _jsx(Translation, {
                tid: partnerDescriptionKey,
                components: {
                    link: /*#__PURE__*/ _jsx(LinkBody, {
                        to: "/contact"
                    }),
                    name: /*#__PURE__*/ _jsx(Translation, {
                        tid: partnerNameKey
                    })
                }
            }) : partnerDescription || partnersDescription
        },
        subHeading: /*#__PURE__*/ _jsx(Translation, {
            tid: "landing.subtitle.v2"
        })
    });
};
PartnerLandingTemplate.propTypes = {
    image: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    name: PropTypes.string.isRequired,
    preTitle: PropTypes.node,
    preTitleKey: PropTypes.string,
    partner: PropTypes.string.isRequired,
    partnerClick: PropTypes.func.isRequired,
    partnerDescription: PropTypes.node,
    partnerDescriptionKey: PropTypes.string,
    partnerNameKey: PropTypes.string
};
var mapDispatchToProps = {
    partnerClick: signupActions.partnerClick
};
export default connect(null, mapDispatchToProps)(PartnerLandingTemplate);
